import Is from "../is"

/**
 * Set value to the given array
 * 
 * @param {object} object
 * @param {string} key
 * @param {any} value
 * @returns {void}
 */
export default function set(object: Record<string, any>, key: string | Array<string>, value: any): void {
    const keys = Is.array(key) ? key : key.split(".")

    if(keys.length === 1) {      
        return object[keys[0]] = value
    } else {
        if(typeof object[keys[0]] === 'undefined') object[keys[0]] = {}

        set(object[keys[0]], keys.slice(1), value)
    }
}